export default "__VITE_ASSET__DNvF99W9__"